<template>
  <div class="display-swipe-wrapper">
    <div v-if="!items.length" class="skeleton-wrapper">
      <van-skeleton :row="5" />
    </div>
    <div v-else>
      <van-swipe :autoplay="3000" indicator-color="#45b97c">
        <van-swipe-item v-for="(item, index) of items" :key="index">
          <display-image :value="item" />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import DisplayImage from './DisplayImage.vue';

export default {
  components: {
    DisplayImage,
  },
  props: {
    items: [Array],
  },
};
</script>
<style lang="less" scoped>
.display-swipe-wrapper {
  .skeleton-wrapper {
    padding-top: 16px;
  }
  /deep/ .van-swipe {
    height: 160px;
    border-radius: 10px;
    /deep/ .van-swipe__indicators {
      position: absolute;
      left: 90%;
    }
  }
}
</style>
